import useActiveShift from 'support/hooks/use-active-shift'
import { useWillPipe } from '@morningtrain/react-helpers'

export default function ResetActiveShiftOnPipe (props) {
  const [activeShift, setActiveShift] = useActiveShift()

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      setActiveShift(null)

      resolve(payload)
    })
  })

  return null
}
